module.exports = __webpack_public_path__ + "img/bus.32cc8eae.svg";